import { motion } from "framer-motion";
import { Reveal } from "../Reveal";
import { ArrowUpRight } from "lucide-react";

const services = [
  {
    n: "01",
    title: "Life Coaching",
    tag: "Clarity & Direction",
    body:
      "One-to-one coaching to help you rediscover purpose, set meaningful goals and move through midlife transitions with confidence and calm.",
    img: "/assets/life-coaching.jpg",
  },
  {
    n: "02",
    title: "Personal Training",
    tag: "Strength for Life",
    body:
      "Tailored fitness programmes designed for women 40+. Build strength, protect your bones and rediscover energy — training that respects your body.",
    img: "https://images.unsplash.com/photo-1619385006580-6f5550cabbb3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    n: "03",
    title: "Menopause Coaching",
    tag: "Support Through Change",
    body:
      "Compassionate, informed guidance through peri-menopause and beyond — managing symptoms, nutrition and mindset so you feel like yourself again.",
    img: "https://images.pexels.com/photos/5992901/pexels-photo-5992901.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  },
  {
    n: "04",
    title: "Temple Spa Skincare",
    tag: "Glow From Within",
    body:
      "As a Temple Spa consultant I'll help you build a nourishing, luxurious skincare ritual — because feeling radiant is part of whole-body wellbeing.",
    img: "/assets/temple-spa.webp",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative py-24 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex items-center gap-4 mb-16">
            <span className="font-serif text-2xl text-gold">03</span>
            <span className="text-[11px] uppercase tracking-[0.3em] text-stone">How We Work Together</span>
            <span className="flex-1 h-px bg-border" />
          </div>
        </Reveal>

        <div className="space-y-6 md:space-y-0">
          {services.map((s, i) => {
            const reverse = i % 2 === 1;
            return (
              <motion.div
                key={s.title}
                data-testid={`service-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                className={`group grid md:grid-cols-12 gap-8 items-center py-10 md:py-16 border-t border-border ${
                  reverse ? "md:[direction:rtl]" : ""
                }`}
              >
                <div className={`md:col-span-6 [direction:ltr]`}>
                  <div className="relative overflow-hidden rounded-[6px] border border-border">
                    <img
                      src={s.img}
                      alt={s.title}
                      className="w-full h-[340px] md:h-[440px] object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-plum/5 transition-colors duration-500 group-hover:bg-transparent" />
                  </div>
                </div>

                <div className="md:col-span-6 [direction:ltr] md:px-6">
                  <div className="flex items-center gap-4">
                    <span className="font-serif text-5xl text-plum/20">{s.n}</span>
                    <span className="text-[11px] uppercase tracking-[0.24em] text-gold">{s.tag}</span>
                  </div>
                  <h3 className="mt-5 font-serif font-light text-4xl md:text-5xl text-plum">{s.title}</h3>
                  <p className="mt-5 max-w-md text-base md:text-lg text-stone leading-relaxed">{s.body}</p>
                  <button
                    data-testid={`service-cta-${i}`}
                    onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
                    className="mt-8 inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.18em] text-plum border-b border-plum/30 pb-1 transition-colors duration-300 hover:border-plum"
                  >
                    Enquire about {s.title}
                    <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </button>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
